<template>
  <div class="harpooners-sidebar">
    <div class="sidebar-header">
      <div class="sidebar-title">🎯 Гарпунщики</div>
    </div>

    <!-- Работающие гарпунщики -->
    <div v-for="h in activeHarpooners" :key="h.IDManager" class="harpooner-item is-working">
      <div class="harpooner-header">
        <div class="harpooner-name">{{ h.manager_name }}</div>
        <div class="harpooner-speed">{{ h.avg_speed.toFixed(1) }} м/ч</div>
      </div>
      <div class="harpooner-body">
        <div class="work-status">📏 Работает</div>
        <div class="work-order">{{ h.current_work.NumZakaz }} - {{ h.current_work.NumPotolok }}</div>
        <div class="work-client">{{ h.current_work.client_name }}</div>
        <div class="work-timer">⏱️ {{ formatRemainingTime(h.current_work.estimated_finish_ts) }}</div>
      </div>
    </div>

    <!-- Свободные гарпунщики -->
    <div v-for="h in idleHarpooners" :key="h.IDManager" class="harpooner-item">
      <div class="harpooner-header">
        <div class="harpooner-name">{{ h.manager_name }}</div>
        <div class="harpooner-speed">{{ h.avg_speed.toFixed(1) }} м/ч</div>
      </div>
      <div class="harpooner-body">
        <div class="work-free">Свободен</div>
      </div>
    </div>

    <!-- Не в работе (не пришли) -->
    <div v-for="h in offWorkHarpooners" :key="h.IDManager" class="harpooner-item is-off-work">
      <div class="harpooner-header">
        <div class="harpooner-name">{{ h.manager_name }}</div>
        <div class="harpooner-speed">{{ h.avg_speed.toFixed(1) }} м/ч</div>
      </div>
      <div class="harpooner-body">
        <div class="work-off">Нет в работе</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

export default {
  name: 'HarpoonersSidebar',
  props: {
    harpooners: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const currentTime = ref(Date.now())
    let timerInterval = null

    const activeHarpooners = computed(() => {
      return props.harpooners.filter(h => h.at_work === true && h.current_work !== null)
    })

    const idleHarpooners = computed(() => {
      return props.harpooners.filter(h => h.at_work === true && h.current_work === null)
    })

    const offWorkHarpooners = computed(() => {
      return props.harpooners.filter(h => h.at_work === false)
    })

    /**
     * Форматирует оставшееся время до завершения работы
     * @param {number} estimatedFinishTs - Unix timestamp в секундах (время завершения)
     * @returns {string} - Строка формата "ММ:СС" или "Завершено"
     */
    const formatRemainingTime = (estimatedFinishTs) => {
      if (!estimatedFinishTs) return '00:00'

      // Текущее время в секундах (Unix timestamp)
      const nowSeconds = Math.floor(currentTime.value / 1000) + 18000

      // Оставшееся время в секундах
      const remainingSeconds = estimatedFinishTs - nowSeconds

      // Если время вышло
      if (remainingSeconds <= 0) {
        return 'Завершено'
      }

      // Конвертируем в минуты и секунды
      const minutes = Math.floor(remainingSeconds / 60)
      const seconds = remainingSeconds % 60

      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    }

    // Обновляем текущее время каждую секунду для обратного отсчета
    onMounted(() => {
      timerInterval = setInterval(() => {
        currentTime.value = Date.now()
      }, 1000)
    })

    onBeforeUnmount(() => {
      if (timerInterval) {
        clearInterval(timerInterval)
      }
    })

    return {
      activeHarpooners,
      idleHarpooners,
      offWorkHarpooners,
      formatRemainingTime
    }
  }
}
</script>

<style scoped>
.harpooners-sidebar {
  height: fit-content;
  width: 16rem;
  background: #fff;
  border-left: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  padding: 1rem;
  overflow-y: auto;
  box-sizing: border-box;
  /* height: 50%; */
  border-radius: 10px;
}

.sidebar-header {
  margin-bottom: 0.75rem;
  text-align: center;
}

.sidebar-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #111827;
}

.harpooner-item {
  background: #f9fafb;
  border-radius: 0.5rem;
  padding: 0.625rem;
  margin-bottom: 0.5rem;
  border: 2px solid #e5e7eb;
}

.harpooner-item.is-working {
  border-color: #10b981;
  background: #ecfdf5;
}

.harpooner-item.is-off-work {
  border-color: #ef4444;
  background: #fef2f2;
  opacity: 0.7;
}

.harpooner-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.harpooner-name {
  font-size: 0.75rem;
  font-weight: 700;
  color: #111827;
}

.harpooner-speed {
  font-size: 0.625rem;
  font-weight: 600;
  color: #10b981;
  background: #fff;
  padding: 0.125rem 0.375rem;
  border-radius: 0.375rem;
}

.harpooner-body {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.work-status {
  font-size: 0.625rem;
  font-weight: 600;
  color: #10b981;
}

.work-order {
  font-size: 0.6875rem;
  font-weight: 700;
  color: #374151;
}

.work-client {
  font-size: 0.625rem;
  color: #6b7280;
}

.work-timer {
  font-size: 0.625rem;
  font-weight: 600;
  color: #f59e0b;
  margin-top: 0.125rem;
}

.work-free {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #9ca3af;
  text-align: center;
}

.work-off {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #ef4444;
  text-align: center;
}
</style>
